import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-news-01',
  standalone: true,
  templateUrl: '../../assets/news-01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamNews01Icon {}
